import Modal from "@/components/ui/modal";
import FeedbackForm from "./feedback-form";

type TFeedbackModalProps = {
	isModalOpen: boolean;
	currentRating: number;
	closeModal: () => void;
	onRating: (newRating: number) => void;
	onSubmit: () => void;
};

const FeedbackModal = ({
	isModalOpen,
	currentRating,
	closeModal,
	onRating,
	onSubmit,
}: TFeedbackModalProps) => {
	return (
		<Modal title="Feedback Form" isOpen={isModalOpen} onClose={closeModal} className="max-w-lg">
			<FeedbackForm onRating={onRating} currentRating={currentRating} onSubmit={onSubmit} />
		</Modal>
	);
};

export default FeedbackModal;
